import { authGet } from '../../api';
import { camelizeKeys } from 'humps';

const Recipe = {
  async getRecipesByProduct(id) {
    const response = await authGet(`/v2/products/${id}/nutrition_values`);

    const data = await response.json().then(b => camelizeKeys(b));
    return data;
  },
};

export default Recipe;
